import { Entity } from '@backstage/catalog-model';

export function extractInitials(name: string) {
  const names = name.trim().split(' ');
  const firstName = names[0] ?? '';
  const lastName = names.length > 1 ? names[names.length - 1] : '';
  return firstName && lastName
    ? `${firstName.charAt(0)}${lastName.charAt(0)}`
    : firstName.charAt(0);
}

export const formatTimestampToDate = (timestamp: number) => {
  const date = new Date(timestamp);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const getNameFromEmail = (email: string) => {
  const namePart = email.split('@')[0];
  return namePart;
};

export function formatLastApproval(iso: string): string {
  const date = new Date(iso);

  const dayMonth = new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
  }).format(date);

  const year = new Intl.DateTimeFormat('en-GB', {
    year: 'numeric',
  }).format(date);

  const timePart = new Intl.DateTimeFormat('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(date);

  return `Last Approval:\n${dayMonth}, ${year} at ${timePart}`;
}

export const navigateTo = (url: string) => {
  if (url.startsWith('mailto:')) {
    window.location.href = url;
  } else {
    window.open(url, '_blank');
  }
};

/**
 * The role and department of a user, from the annotations on the User
 * entities that the user-profile-info catalog module provides. Other User
 * entities have neither.
 */
export function getUserRoleAndDepartment(entity: Entity): {
  role?: string;
  department?: string;
} {
  const annotations = entity.metadata.annotations;
  return {
    role: annotations?.['user-role'],
    department: annotations?.['user-department'],
  };
}
